import React from 'react';
import { TextField } from '@material-ui/core';

export const BaseSelectField = ({
	title,
	name,
	error,
	onChange,
	value,
	options,
}) => {
	return (
		<TextField
			fullWidth
			error={error}
			label={title}
			margin='dense'
			name={name}
			onChange={onChange}
			required
			select
			// eslint-disable-next-line react/jsx-sort-props
			SelectProps={{ native: true }}
			value={value}
			variant='outlined'
		>
			{options.map(option => (
				<option key={option.value} value={option.value}>
					{option.label}
				</option>
			))}
		</TextField>
	);
};

export default BaseSelectField;
